import * as _superstruct2 from "superstruct";
var _superstruct = "default" in _superstruct2 ? _superstruct2.default : _superstruct2;
import _base from "./base64";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChecksumStruct = void 0;
const superstruct_1 = _superstruct;
const base64_1 = _base;
exports.ChecksumStruct = (0, superstruct_1.size)((0, base64_1.base64)((0, superstruct_1.string)(), {
  paddingRequired: true
}), 44, 44);
//# sourceMappingURL=checksum.js.map
export default exports;